const InstalledEquipment = {

    // FIELDS
    "short": "Short",
    "detailed": "Detailed",
    "department": "Department",
    "location": "Location",
    "component": "Component",
    "equipment": "Equipment",
    "part_number": "Part Number",
    "search": "Search",

    // PAGE HEADER
    "report": "Report",
    "installed_equipment": "Installed Equipment",

    // TABLE HEADER
    "table_department": "DEPARTMENT",
    "table_location": "LOCATION",
    "table_component": "COMPONENT",
    "table_equipment": "EQUIPMENT",
    "table_make": "MAKE",
    "table_new_part_number": "NEW PART NUMBER",
    "table_old_part_number": "OLD PART NUMBER",
    "table_km_item_code": "KM ITEM CODE",
    "table_installed_qty": "INSTALLED QTY",
}

export default InstalledEquipment;